'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGContainer = require('../SVGContainer');

var _SVGContainer2 = _interopRequireDefault(_SVGContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProblemIcon = function ProblemIcon(props) {
  return _react2.default.createElement(
    _SVGContainer2.default,
    props,
    _react2.default.createElement('path', { d: 'M16.2039697,4 L15.990061,4.00208691 C12.7762135,4.05843359 9.75018824,5.35753754 7.47336509,7.66044712 C5.17880317,9.980052 3.94648046,13.0165118 4.00178368,16.2115771 C4.11656395,22.8239641 9.2973279,28.0036846 15.7970215,28.0036846 L16.0088433,28.0015977 C22.734967,27.8857739 28.1139878,22.4076247 27.9981641,15.7931509 C27.8833838,9.18076395 22.7026198,4 16.2039697,4 L16.2039697,4 Z M15.4777236,10.2607419 C15.4787671,9.97274781 15.7125015,9.73901344 16.0004956,9.73901344 C16.2874463,9.73901344 16.5222241,9.97274781 16.5211806,10.2607419 L16.5211806,17.5649409 C16.5222241,17.852935 16.2874463,18.0866694 16.0004956,18.0866694 C15.7125015,18.0866694 15.4787671,17.852935 15.4777236,17.5649409 L15.4777236,10.2607419 L15.4777236,10.2607419 Z M16.0192778,22.2604973 L16.0004956,22.2604973 C15.4318115,22.2604973 14.9664297,21.8055501 14.9570386,21.2358225 C14.946604,20.6598343 15.4057251,20.1840179 15.9817134,20.1746268 C15.9879741,20.1746268 15.9942349,20.1735833 16.0004956,20.1735833 C16.5691797,20.1735833 17.033518,20.629574 17.0439526,21.1993016 C17.0543872,21.7752898 16.5931792,22.2500627 16.0192778,22.2604973 L16.0192778,22.2604973 Z' })
  );
};

ProblemIcon.propTypes = {
  size: _react.PropTypes.oneOf(['small', 'medium', 'large'])
};

exports.default = ProblemIcon;